import RequirementDetailSection from 'features/requirements/sections/RequirementDetailSection';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { loadPortalConfig } from 'features/shared/helpers/modules';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const portalConfig = loadPortalConfig();

type RouteProps = {
  requirementId: string;
}

const RequirementAdminDetailPage = () => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  // router
  const { requirementId } = useParams<RouteProps>();

  // render
  return (
    <RenderWrapper isVisible={() => portalConfig.enableRequirementPresentation}>
      <Header
        title={tLabels("requirementAdminDetailPage.title")}
        includeBreadcrumbs
        links={[
          { to: "/admin/email-requirements", text: tLabels("requirementsAdminPage.title") },
        ]}
      />
      <ModuleContent>
        <RequirementDetailSection
          requirementId={requirementId}
          forAdminUse
        />
      </ModuleContent>
    </RenderWrapper>
  );
}

export default RequirementAdminDetailPage;
